import { useMutation } from '@tanstack/react-query';
import API from 'api/API';

export const useDeliveriesMutation = () => {
  return useMutation({
    mutationFn: (params: Parameters<typeof API.deliveries.getDeliveries>[0]) => API.deliveries.getDeliveries(params),
  });
};
